import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { mapFields } from "src/app/features/ApplicationConfigurations/components/appConfigsUtils";
import type { AppConfigsFieldEditableItem, SubEntity } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import { EditableList } from "../../../../../components/EditableList/EditableList";
import type { EditableListColumnConfig } from "../../../../../components/EditableList/types/EditableListConfig";
import type { EditableListRemoveStrategy } from "../../../../../components/EditableList/types/EditableListRemoveStrategy";
import { useLoadFormDefinitionQuery } from "../../../../../components/Form/services/server/serverApi";
import type { AntCustomFormField, CommonFieldAttributes } from "../../../../../components/Form/types/types";

export interface SubEntityEditableListProps extends AntCustomFormField<string>, CommonFieldAttributes {
    subEntityData: SubEntity;
    onChangeCallback: Function;
    columnConfig: EditableListColumnConfig[];
    removeItems: EditableListRemoveStrategy;
    isFetching?: boolean;
}

export const SubEntityEditableList: FC<SubEntityEditableListProps> = ({
    subEntityData,
    onChangeCallback,
    columnConfig,
    removeItems,
    isFetching,
}) => {
    const { t } = useTranslation();

    // get formModel data for subEntity
    const { data, isFetching: subEntityIsFetching } = useLoadFormDefinitionQuery(subEntityData.reference ?? "", {
        skip: subEntityData.reference === "",
    });
    const subEntityFields = data?.formConfiguration?.tabs[0].fields;
    const dataModel: SubEntity = {
        key: subEntityData.key,
        reference: subEntityData.reference,
    };

    // convert formModel data to collapseModel Data
    if (subEntityFields) {
        dataModel.subEntityFields = mapFields(subEntityFields, t);
    }

    const onChangeCallbackSubEntity = (onChangeData: AppConfigsFieldEditableItem[]) => {
        if (!subEntityData) return;

        const entity = subEntityData;
        entity.subEntityFields = onChangeData;

        if (onChangeCallback) {
            onChangeCallback(entity);
        }
    };

    return (
        (subEntityData && (
            <EditableList<AppConfigsFieldEditableItem>
                value={subEntityData.subEntityFields?.length ? subEntityData.subEntityFields : dataModel.subEntityFields}
                onChange={onChangeCallbackSubEntity}
                columns={columnConfig}
                removeItems={removeItems}
                addItems={false}
                isFetching={isFetching || subEntityIsFetching}
                name={`${subEntityData.key}`}
            />
        )) ||
        null
    );
};
